import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPembelianAkunService = new CrudCustom('/pembelian-akun');
export default TransaksiPembelianAkunService;
